const mediaQuery = window.matchMedia('(min-width: 768px)');

if (mediaQuery.matches) {
    document.querySelectorAll('.desktop-iframe__iframe').forEach((iframe) => {
        if (typeof iframe.dataset.src === 'string' && iframe.dataset.src !== '') {
            iframe.src = iframe.dataset.src;
        }
    });
} else {
    document.querySelectorAll('.desktop-iframe').forEach((iFrameContainer) => iFrameContainer.remove());
}
